<cobalt-global-header
  headerTitle="Crew Training"
  [isOptimized]="false"
  [sideNavigationRef]="sideNavigationRef"
>
  <cobalt-avatar
    [cobaltTriggerUserMenuFor]="menu"
    firstName="{{ userProfile.firstName }}"
    lastName="{{ userProfile.lastName }}"
  ></cobalt-avatar>
  <cobalt-user-menu #menu [userProfile]="userProfile">
    <a cobaltLinkPrimary (click)="helpClicked()">
      <cobalt-icon
        name="user-avatar-outline"
        role="menuitem"
        size="medium"
      ></cobalt-icon
      >Help</a
    >
    <a cobaltLinkPrimary (click)="settingClicked()" *ngIf="isSMSNotificationSettingEnabled">
      <cobalt-icon
        name="cog-outline"
        role="menuitem"
        size="medium"
      ></cobalt-icon
      >Settings</a
    >
    <a cobaltLinkPrimary (click)="logoutClicked()">
      <cobalt-icon
        name="log-out-outline"
        role="menuitem"
        size="medium"
      ></cobalt-icon
      >Log Out</a
    >
    <ng-container cobaltUserMenuFooter>
      <div class="header-footer">
        <a cobaltLinkSecondary (click)="eulaClicked()" role="menuitem"
          >Privacy Policy • License Agreement</a
        >
        <span [attr.aria-label]="'Build number: ' + buildNumber"
          >Build number: {{ buildNumber }}</span
        >
      </div>
    </ng-container>
  </cobalt-user-menu>
</cobalt-global-header>
